import { NoSymbolIcon, XMarkIcon } from "@heroicons/react/20/solid";
import React from "react";
import TimePicker from "react-time-picker/dist/entry.nostyle";
import { ToggleWithIcon } from "../../DanitComponents/Toggles/ToggleWithIcon";
import "./availability-by-day-popup.css";
// import 'react-time-picker/dist/TimePicker.css'

const AvailabilityByDayPopup = (props) => {
  const [dayAvail, setDayAvail] = React.useState(
    props.availability[props.dayToEdit]
  );
  const [wholeAvail, setWholeAvail] = React.useState({});
  const [available, setAvailable] = React.useState(true);
  const [comingFromHome, setComingFromHome] = React.useState(false);

  const initialRend = React.useRef(true);

  React.useEffect(() => {
    setWholeAvail(props.availability);
  }, []);

  React.useEffect(() => {
    if (available) {
      if (props.availability[props.dayToEdit].length > 0) {
        setDayAvail(props.availability[props.dayToEdit]);
      } else {
      }
      //setAvailable(true)
    } else {
      setDayAvail([]);
      //setAvailable(false)
    }
  }, [available]);

  React.useEffect(() => {
    console.log(dayAvail);
    if (initialRend.current) {
      initialRend.current = false;
    } else {
      let curAvail = wholeAvail;
      curAvail[props.dayToEdit] = dayAvail;
      setWholeAvail({ ...curAvail });
    }
    // for(let i = 0; i < dayAvail.length; i++) {
    //     if(!isValid(dayAvail[i].start)) {
    //         dayAvail[i].start = "9:00"
    //     } else if (!isValid(dayAvail[i].end) ) {
    //         dayAvail[i].end = "20:00"
    //     }
    // }
  }, [dayAvail]);

  const closeWrapperClick = (id) => {
    if (id === "availability-by-day-popup-wrapper") {
      props.setAvailabilityByDay("");
    }
  };
  const changeTimeSettings = (i, place, value) => {
    console.log(value);
    let myDay = dayAvail;
    myDay[i][place] = value;
    setDayAvail([...myDay]);
  };
  const addAnInterval = () => {
    setDayAvail((oldArray) => [...oldArray, { start: "9:00", end: "20:00" }]);
  };
  const deleteSlot = (i) => {
    let array = dayAvail;
    array.splice(i, 1);
    setDayAvail([...array]);
  };
  const notAvailableToday = () => {
    setDayAvail([]);
    setTimeout(() => {
      props.updateAndCloseAvailabilityModal(wholeAvail);
    }, 100);
  };
  const changeNotesForDay = (e) => {};
  return (
    <div
      className="availability-by-day-popup-wrapper"
      id="availability-by-day-popup-wrapper"
      onClick={(e) => closeWrapperClick(e.target.id)}
    >
      <div className="availability-by-day-popup">
        <div className="availability-by-day-popup__top-section">
          <div className="availability-by-day-popup__toggle-wrapper">
            <div style={{ fontSize: "12px", width: "20px" }}>
              {available ? "Available" : "Unavailable"}
            </div>
            <div>
              <ToggleWithIcon enabled={available} setEnabled={setAvailable} />
            </div>
          </div>
          <XMarkIcon
            className="availability-day-close-x"
            color="lightGray"
            onClick={() =>
              closeWrapperClick("availability-by-day-popup-wrapper")
            }
          />
        </div>
        <div className="availability-by-day-popup__header">
          {props.dayToEdit}
        </div>
        <div className="availability-by-day__header-orange-line"></div>
        <div className="availability-by-day__center-area">
          {available ? (
            <div>
              {dayAvail.map((slot, index) => (
                <div
                  key={index}
                  className="availability-by-day-popup__time-block-wrapper"
                >
                  <div className="availability-by-day-popup__time-block__input-section">
                    <TimePicker
                      value={slot.start}
                      onChange={(value) =>
                        changeTimeSettings(index, "start", value)
                      }
                    />
                  </div>
                  <div className="availability-by-day-popup__minus-sign"></div>
                  <div className="availability-by-day-popup__time-block__input-section">
                    <TimePicker
                      value={slot.end}
                      onChange={(value) =>
                        changeTimeSettings(index, "end", value)
                      }
                    />
                  </div>
                  <div className="availability-by-day-popup__time-block__input-section">
                    <XMarkIcon
                      className="availability-day-close-x"
                      color="lightGray"
                      onClick={() => deleteSlot(index)}
                    />
                  </div>
                </div>
              ))}
              <div style={{ textAlign: "center" }}>
                <div
                  className="availability-by-day-popup__new-interval-button"
                  onClick={() => addAnInterval()}
                >
                  + Add an interval
                </div>
              </div>
            </div>
          ) : (
            <NoSymbolIcon color="#EBEBEB" height={149} />
          )}
        </div>
        <div className="availability-by-day-popup__bottom-section">
          {/* <div style={{width: '90%', margin: '0px auto 10px auto'}}><InputWithInsetLabel label={'Notes'} placeholder={`Anything else we should know about ${props.dayToEdit}s?`} value={(e) => changeNotesForDay(e.target.value)} /></div>
                    {available && <div className='coming-from-home-toggle-wrapper'>
                        <ToggleWithIcon enabled={comingFromHome} setEnabled={setComingFromHome} />
                        <div className='coming-from-home-toggle-label'>Coming from home</div>
                    </div>} */}
          <div className="availability-by-day-popup__bottom-section__btn-wrapper">
            <div
              className="availability-by-day-popup__cancel-button"
              onClick={() => props.setAvailabilityByDay("")}
            >
              Go Back
            </div>
            <div
              className="availability-by-day-popup__apply-button"
              onClick={() => props.updateAndCloseAvailabilityModal(wholeAvail)}
            >
              Save availability
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AvailabilityByDayPopup;
